import { useQuery } from "@tanstack/react-query";
import { baseUrl } from "../../../../../baseUrl";
import { createFileRoute } from "@tanstack/react-router";
import { fetchWithAuthHandling } from "../../../../../authHandling";
import { Box, Container, Typography, CircularProgress } from "@mui/material";
import { ToolsSections } from "../../../../../components/buyers/tools/toolsSection";

export const Route = createFileRoute(
  "/_app/buyers/$buyerId/_buyerLayout/tools"
)({
  loader: ({ params }) => {
    const { buyerId } = params;
    return { buyerId };
  },
  component: RouteComponent
});

function RouteComponent() {
  const { buyerId } = Route.useLoaderData();
  const {
    data: prefillData,
    isLoading,
    error
  } = useQuery({
    queryKey: ["buyerTools", buyerId],
    queryFn: async () => {
      const response = await fetchWithAuthHandling(
        `${baseUrl}/buyers/${buyerId}/tools/1/prefill`,
        {
          method: "GET",
          credentials: "include"
        }
      );
      if (!response.ok) {
        throw new Error("Failed to fetch buyer data");
      }
      return response.json();
    }
  });

  return (
    <Container
      sx={{
        my: 5,
        maxWidth: {
          xs: "97%"
        }
      }}
    >
      {error && <Typography>Error loading data: {error.message}</Typography>}
      {isLoading ? (
        <Box
          sx={{
            display: "flex",
            alignItems: "center",
            justifyContent: "center"
          }}
        >
          <CircularProgress />
        </Box>
      ) : (
        <ToolsSections prefillData={prefillData} buyerId={buyerId} />
      )}
    </Container>
  );
}
